import { useMutation, useQueryClient } from 'react-query';

import { updateTrap as update } from 'api/traps/updateTrap';

const useUpdateTrap = () => {
  const queryClient = useQueryClient();
  const {
    isSuccess,
    mutate: updateTrap,
    isLoading,
  } = useMutation(update, {
    onSuccess: () => {
      queryClient.invalidateQueries([
        'useGetSbsTraps',
        'FeromonInsectsTable',
        'ClawingInsectsTable',
        'useGetBsTraps',
        'smartMultiTraps',
      ]);
    },
  });

  return {
    isSuccess,
    updateTrap,
    isLoading,
  };
};

export default useUpdateTrap;
